var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { TabsList } from './subcomponents';
const LEFT_ARROW_KEY = 'ArrowLeft';
const RIGHT_ARROW_KEY = 'ArrowRight';
const Tabs = (props) => {
    const { currentTab: externalActiveTabIndex, onTabClick: onTabChanged } = props, rest = __rest(props, ["currentTab", "onTabClick"]);
    const { defaultTab = 0, className = '', children } = rest;
    const [internalActiveTabIndex, setInternalActiveTabIndex] = React.useState(defaultTab);
    const activeTabIndex = externalActiveTabIndex !== undefined
        ? externalActiveTabIndex
        : internalActiveTabIndex;
    const activeTabId = children[activeTabIndex].props.id;
    const tabsRef = useRef([]);
    const childrenSize = children.length - 1;
    const handleTabClick = (index) => {
        onTabChanged === null || onTabChanged === void 0 ? void 0 : onTabChanged(index);
        setInternalActiveTabIndex(index);
    };
    const handleKeyDown = ({ key }) => {
        let newActiveIndex = activeTabIndex;
        if (key === LEFT_ARROW_KEY) {
            newActiveIndex = activeTabIndex === 0 ? childrenSize : activeTabIndex - 1;
        }
        if (key === RIGHT_ARROW_KEY) {
            newActiveIndex = childrenSize === activeTabIndex ? 0 : activeTabIndex + 1;
        }
        onTabChanged === null || onTabChanged === void 0 ? void 0 : onTabChanged(newActiveIndex);
        setInternalActiveTabIndex(newActiveIndex);
        tabsRef.current.at(newActiveIndex).focus();
    };
    return (_jsxs(_Fragment, { children: [_jsx(TabsList, Object.assign({ className: className }, rest, { "aria-orientation": "horizontal", role: "tablist", onKeyDown: handleKeyDown }, { children: children.map((element, index) => {
                    return React.cloneElement(element, {
                        index,
                        isActive: activeTabIndex === index,
                        key: `${index + 1}`,
                        handleTabClick,
                        forwardRef: (refElement) => {
                            var _a, _b;
                            if (((_a = tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current) === null || _a === void 0 ? void 0 : _a.length) < children.length) {
                                (_b = tabsRef.current) === null || _b === void 0 ? void 0 : _b.push(refElement);
                            }
                        }
                    });
                }) })), _jsx("section", Object.assign({ "aria-labelledby": activeTabId, id: `${activeTabId}-content`, role: "tabpanel", tabIndex: 0 }, { children: children[activeTabIndex] && children[activeTabIndex].props.children }))] }));
};
export default Tabs;
